import { createContext } from "react";
import { type ContextType } from "./types";

export const SubscriptionStaffReviewContextState = createContext<ContextType>({
  data: undefined,
  loading: true,
  globalSubscriptionId: "",
  staffReviewCompleted: false,
  onStaffReviewCompleted: () => {
    // no op
  },
});
